import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20mystical%20forest%20floor%20with%20various%20wild%20mushrooms%20growing%20among%20moss%20and%20fallen%20leaves%2C%20soft%20natural%20sunlight%20filtering%20through%20trees%2C%20warm%20earthy%20tones%20of%20brown%20green%20and%20cream%2C%20atmospheric%20woodland%20photography%20with%20shallow%20depth%20of%20field%2C%20ethereal%20and%20enchanting%20mood&width=1800&height=900&seq=mush-hero-bg&orientation=landscape"
        alt="森林中的野生蘑菇"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-accent-500/90 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium mb-6">
          <i className="ri-shield-check-line"></i>
          <span>权威毒蘑菇鉴别科普平台</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          一分钟识别有毒蘑菇真伪
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          野外采摘蘑菇前必做的安全验证步骤。汇集权威毒蘑菇测试方法、常见误区拆解及专家指导，保障家人饮食安全。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/identification-methods"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
          >
            <i className="ri-search-eye-line"></i>
            查看鉴别方法
          </Link>
          <Link
            to="/category/common-poisonous"
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/30 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
          >
            <i className="ri-alert-line"></i>
            常见毒蘑菇图鉴
          </Link>
        </div>
      </div>
    </section>
  );
}